@if (isLoading) {
<app-loading-spinner [text]="'Negotiations'"></app-loading-spinner>
} @if (negotiation$ | async; as data) {
<div class="pt-2 pb-20 px-4 page-height overflow-auto">
  <div class="my-1 mb-18 mx-auto max-w-2xl">
    <span class="font-medium">Negotiating</span>
    @for (counter of data.counters; track i; let i = $index) {
    <mat-card
      appearance="outlined"
      class="my-card counter-card my-1 w-100 font-medium"
    >
      <mat-card-content [ngClass]="{ 'not-active': i != 0 }">
        <div
          class="flex flex-row gap-4 justify-between items-center px-4 mobile-max:px-2"
        >
          <div>
            @if (counter.originator_id) {
            <mat-chip-set>
              <mat-chip
                aria-label="sent-counter"
                disableRipple="true"
                defaultColor="red"
                class="text-xs"
                [ngClass]="{
                    'green-chip': counter.originator_id == userDetails._id,
                    'purple-chip': counter.originator_id != userDetails._id,
                  }"
              >
                @switch(counter.originator_id == userDetails._id){ @case(true){
                Outgoing } @case(false){ Incoming } }
              </mat-chip>
              @if (data.status === 'Declined') {
              <mat-chip class="red-chip text-xs"> Declined </mat-chip>
              }
            </mat-chip-set>
            } @if ( counter.ship_begin != null && counter.ship_end != null) {
            <div class="flex flex-col flex-wrap">
              {{ counter.ship_begin | date : "MMM d, y" }} -
              {{ counter.ship_end | date : "MMM d, y" }}
            </div>
            } @else {
            <div class="flex flex-col flex-wrap">
              <span class="opacity-60 tablet-min:text-md text-xs"
                >Shipping</span
              >
              {{ data.ship_begin_orig | date : "MMM d, y" }} -
              {{ data.ship_end_orig | date : "MMM d, y" }}
            </div>
            }
          </div>
          <div
            class="flex flex-col items-start font-base justify-center flex-nowrap"
          >
            <span>
              {{ data.currency }}
              $ {{ counter.price_value | priceType }} /
              {{ data.price_units }}
            </span>
            <span>
              {{ counter.volume_value }}
              {{ data.units == "Metric Tonnes" ? "MT" : data.units }}
            </span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    }
  </div>
  <div
    class="text-lg font-medium px-4 mt-4 mb-1 flex flex-row justify-between mx-auto max-w-2xl"
  >
    <span>Original {{ data.lot_type }} Details</span>
    <div class="text-xl font-base">
      <mat-chip-set>
        @if (userDetails._id == data.lot_user_id) {
        <mat-chip
          aria-label="sent-counter"
          disableRipple="true"
          class="text-xs bg-custom-blue purple-chip p-0"
          >My
        </mat-chip>
        }
        <mat-chip
          class="text-xs"
          [ngClass]="{
            'green-chip': data.lot_type === 'Bid',
            'blue-chip': data.lot_type === 'Offer'
          }"
        >
          @switch (data.lot_type) { @case('Bid'){ Bid} @case('Offer'){ Offer} }
        </mat-chip>
      </mat-chip-set>
    </div>
  </div>
  <!-- add here ** -->
  <mat-card class="my-card mb-2 px-4 mx-auto max-w-2xl">
    <mat-card-content class="w-full tablet-max:text-sm text-base">
      <div class="px-2 w-full">
        <div
          id="details-grid"
          class="my-2 w-full grid grid-cols-2 text-left justify-center"
        >
          <div class="light:text-gray-300">Origin</div>
          <div class="font-medium">{{ data.origin }}</div>
          <div class="light:text-gray-300">Crop Type</div>
          <div class="font-medium">{{ data.commodity }}</div>
          @if (data.product_type) {
          <div class="light:text-gray-300">Product Type</div>
          <div class="font-medium">{{ data.product_type }}</div>
          }
          <div class="light:text-gray-300">Grade</div>
          <div class="font-medium">{{ data.grade }}</div>
          <div class="light:text-gray-300">Specifications</div>
          <div class="font-medium">
            @for (spec of data.specifications; track spec) { @if (spec.value !==
            '') {
            <span> {{ spec.title }} - {{ spec.value }} <br /> </span>
            } }
          </div>
          @if(data.documentations && data.documentations.length){
          <div class="text-sm light:text-gray-300">Documentations</div>
          <div
            class="font-medium text-base czol-span-2 doc-container text-right"
          >
            @for (doc of data.documentations; track doc) { @if (doc.value !==
            null) {
            <p class="text-left doc-row">
              {{ doc.title }} -
              <span class="font-normal text-sm">{{ doc.value }}</span>
            </p>
            } }
          </div>
          }
          <div class="font-base light:text-gray-300">Price</div>
          <div class="font-medium">
            {{ data.currency }}
            {{ data.price_value_orig | priceType }}
            /
            {{ data.units === "Metric Tonnes" ? "MT" : data.units }}
          </div>
          <div class="light:text-gray-300">Volume</div>
          <div class="font-medium">
            {{ data.volume_value_orig | number }}
            {{ data.units === "Metric Tonnes" ? "MT" : data.units }}
          </div>
          <div class="light:text-gray-300">Delivery Type</div>
          <div class="font-medium">
            {{ data.delivery_type }}
          </div>
          <div class="light:text-gray-300">Location</div>
          <div style="text-wrap: wrap" class="font-medium">
            {{ data.destination }}
          </div>
          <div class="light:text-gray-300">Shipping</div>
          <div class="font-medium">
            <div>
              {{ data.ship_begin_orig | date : "MMM d, y" }} -
              {{ data.ship_end_orig | date : "MMM d, y" }}
            </div>
          </div>
          <div class="light:text-gray-300">Rules to Govern</div>
          <div class="font-medium">
            {{ data.rules_to_govern }}
          </div>
          <div class="light:text-gray-300">Grades/Weights to Govern</div>
          <div class="font-medium">
            {{ data.weight_grade_to_govern }}
          </div>
          <div class="light:text-gray-300">Payment terms</div>
          <div class="font-medium">
            {{ data.payment_term }}
          </div>
          <div class="light:text-gray-300" style="border-color: transparent">
            Additional Notes
          </div>
          <div class="font-medium" style="border-color: transparent">
            {{ data.additional_info || "-" }}
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  @if (data.status !== 'Declined') {
  <div class="btns-container fixed bottom-4 pointer-events-auto left-0 right-0">
    @if (data.user_id == userDetails._id) {
    <button
      class="cursor-pointer button-transition bg-custom-danger text-white text-md p-4 rounded-full flex items-center justify-center w-40"
      style="z-index: 5"
      [style.opacity]="buttonOpacity"
      (click)="revoke(data._id)"
    >
      Revoke
    </button>
    } @if (activeCounter.originator_id != userDetails._id) {
    <div
      (click)="counter()"
      class="hover:cursor-pointer button-transition bg-custom-green text-white text-md p-4 rounded-full flex items-center justify-center w-40"
      [style.opacity]="buttonOpacity"
    >
      Counter
    </div>
    } @if (activeCounter.originator_id != userDetails._id) {
    <button
      class="button-transition bg-custom-blue text-white text-md p-4 rounded-full flex items-center justify-center w-40"
      [style.opacity]="buttonOpacity"
      (click)="accept()"
    >
      Accept
    </button>
    } @if (data.lot_user_id == userDetails._id) {
    <button
      class="cursor-pointer button-transition bg-custom-danger text-white text-md p-4 rounded-full flex items-center justify-center w-40"
      style="z-index: 5"
      [style.opacity]="buttonOpacity"
      (click)="decline(data._id)"
    >
      Decline
    </button>
    }
    <!-- <a
              [routerLink]="['update']"
              *ngIf="activeCounter.originator_id == userDetails._id"
              > -->
    @if (activeCounter.originator_id == userDetails._id) {
    <div
      (click)="update()"
      class="hover:cursor-pointer button-transition bg-custom-orange text-white text-md p-4 rounded-full flex items-center justify-center w-40"
      [style.opacity]="buttonOpacity"
    >
      Update
    </div>
    }
    <!-- </a> -->
  </div>
  }
</div>
}
